import { depthFirst } from 'helpers/treeHelpers';
import { FilterOperations as FO } from 'business/definitions';

const stripColons = (value: string) => value.replace(/::$/, '');

/**
 * Checks if a node value is in the initial filter of not.
 * If so, it also returns if his children are all included (meaning if it has :: after its name)
 */
const isInInitialFilter = (
    value: string,
    navigationField: string,
    queryFilters: QueryFilterT[],
): { isInInitialFilter: boolean; isSubtreeSelected: boolean } => {
    const response = {
        isInInitialFilter: false,
        isSubtreeSelected: false,
    };

    const queryFilter = queryFilters.find((e) => e.field === navigationField);
    if (!queryFilter || !queryFilter.value) {
        return response;
    }
    const included = queryFilter.value.split('|');

    included.forEach((e) => {
        if (stripColons(e) === value) {
            response.isInInitialFilter = true;
            if (e.endsWith('::')) {
                response.isSubtreeSelected = true;
            }
        }
    });
    return response;
};

const filterQueryFilter = (
    possibleNodes: TreeT[],
    navigationField: string,
    queryFilters: QueryFilterT[],
): string => {
    const queryFilter = queryFilters.find((e) => e.field === navigationField);
    if (!queryFilter || !queryFilter.value) {
        return '';
    }
    const included = queryFilter.value.split('|');
    const possibleNodesValue = possibleNodes.map((e) => e.value);

    return included
        .filter((e) => possibleNodesValue.includes(stripColons(e)))
        .join('|');
};

const includeSubTree = (currentNode: TreeT): string =>
    currentNode.children.map((c) => `${c.value}::`).join('|');

export const getNavigationFilterForTree = (
    navigationField: string,
    currentNode: TreeT,
    queryFilters: QueryFilterT[],
): QueryFilterT => {
    const navigationFilter: QueryFilterT = {
        field: navigationField,
        operation: FO.in_,
        value: '',
        isNavigation: true,
    };

    const currentNodeInFilter = isInInitialFilter(
        currentNode.value,
        navigationField,
        queryFilters,
    );
    if (
        currentNodeInFilter.isInInitialFilter &&
        currentNodeInFilter.isSubtreeSelected
    ) {
        // if the parent is included in the filter and has ::, we include the children with their children
        navigationFilter.value = includeSubTree(currentNode);
    } else if (!currentNodeInFilter.isInInitialFilter) {
        // it is not in the filter so it means that one of his parents had ::, we include the children with their children
        navigationFilter.value = includeSubTree(currentNode);
    } else {
        // otherwise, we take the init filter and remove the nodes outside the part of the tree we want to look at
        const allChildren = depthFirst(currentNode).filter(
            (e) => e !== currentNode,
        );
        navigationFilter.value = filterQueryFilter(
            allChildren,
            navigationField,
            queryFilters,
        );
    }
    return navigationFilter;
};
